import React, { useState, useEffect } from 'react';
import { WifiIcon } from 'lucide-react';
import TemperatureChart from './TemperatureChart';
import Card from '../../config/ChowaCard';
import SettingsForm from './SettingsForm';
import { useChowaTheme } from '../../config/chowaThemeContext';
import { commonStyles } from '../../../../common/components/Layout/DashboardLayout';
import classNames from 'classnames';

const ConnectionStatus = ({ wsStatus }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case '接続中':
        return 'text-green-500';
      case '接続試行中':
        return 'text-yellow-500';
      case '未接続':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };

  return (
    <div>
      <h2 className={commonStyles.text.title}>接続状態</h2>
      <div className="flex items-center mt-2">
        <WifiIcon className={`mr-2 ${getStatusColor(wsStatus)}`} />
        <span className={commonStyles.text.body}>TMS#000: </span>
        <span className={`ml-2 ${getStatusColor(wsStatus)}`}>
          {wsStatus}
          {wsStatus === '接続試行中' && <span className="animate-pulse">...</span>}
        </span>
      </div>
    </div>
  );
};

const TMS000 = () => {
  const [wsStatus, setWsStatus] = useState('未接続');
  const { clearSeriesColor } = useChowaTheme();

  // TMSページではデフォルトテーマを使用
  useEffect(() => {
    clearSeriesColor();
  }, [clearSeriesColor]);

  return (
    <div className={commonStyles.layout.container}>
      <div className={commonStyles.layout.content}>
        <div className={classNames(
          commonStyles.grid.default,
          commonStyles.grid.responsive.lg
        )}>
          {/* 左側のカラム：接続状態と温度モニタリング */}
          <div className="lg:col-span-2 space-y-6">
            {/* 接続状態 */}
            <Card className={commonStyles.card.padding.default}>
              <ConnectionStatus wsStatus={wsStatus} />
            </Card>

            {/* 温度モニタリング */}
            <Card className={commonStyles.card.padding.default}>
              <h2 className={classNames(commonStyles.text.title, "text-center mb-4")}>
                Temperature Chart
              </h2>
              <div className="w-full h-[300px] lg:h-[600px]">
                <TemperatureChart />
              </div>
            </Card>
          </div>

          {/* 右側のカラム：設定 */}
          <div className="lg:col-span-1">
            <Card className={commonStyles.card.padding.default}>
              <SettingsForm wsStatus={wsStatus} setWsStatus={setWsStatus} />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TMS000;